import { Controller } from "@hotwired/stimulus"
import { ActionTextAttachmentNode } from "@37signals/lexxy"

export default class extends Controller {
  static values = {
    attachmentsSize: Number
  }

  connect() {
    this.element.addEventListener("lexxy:file-accept", this.checkFile)
    this.element.addEventListener("lexxy:initialize", this.addMutationListener)
    this.addMutationListener()
  }

  disconnect() {
    this.removeListeners()
  }

  addMutationListener = () => {
    if (this.removeMutationListener || !this.editor) return

    // There is currently no event for when an attachment is removed
    this.removeMutationListener = this.editor.registerMutationListener(ActionTextAttachmentNode, (mutatedNodes, { prevEditorState }) => {
      for (const [nodeKey, mutation] of mutatedNodes) {
        if (mutation === 'destroyed') {
          const destroyedNode = prevEditorState._nodeMap.get(nodeKey);

          if (destroyedNode) {
            this.attachmentsSizeValue -= destroyedNode.fileSize;
          }
        }
      }
    });
  }

  removeListeners() {
    this.element.removeEventListener("lexxy:file-accept", this.checkFile)
    this.element.removeEventListener("lexxy:initialize", this.addMutationListener)
    this.removeMutationListener?.()
    this.removeMutationListener = null
  }

  checkFile = (event) => {
    const file = event.detail.file

    if (this.invalidExtensions.includes(this.fileExtension(file.name))) {
      event.preventDefault()
      alert("File type not supported.")
    } else if (this.attachmentsSizeValue + file.size > 2097152) {
      event.preventDefault()
      alert("File too large. Attached file(s) must be less than 2MB total.")
    } else {
      this.attachmentsSizeValue += file.size
    }
  }

  get fileExtension() {
    return (filename) => filename.slice((filename.lastIndexOf(".") - 1 >>> 0) + 2)
  }

  get invalidExtensions() {
    // https://postmarkapp.com/developer/user-guide/send-email-with-api#attachments
    // (see Forbidden File Types)
    return [
      "vbs", "exe", "bin", "bat", "chm", "com", "cpl", "crt", "hlp", "hta",
      "inf", "ins", "isp", "jse", "lnk", "mdb", "pcd", "pif", "reg", "scr",
      "sct", "shs", "vbe", "vba", "wsf", "wsh", "wsl", "msc", "msi", "msp",
      "mst"
    ]
  }

  get editor() {
    return this.element.querySelector("lexxy-editor")?.editor
  }
}
